import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { getFirebase } from 'react-redux-firebase';
import { getFirestore } from 'redux-firestore';

import rootReducer from './Reducers';

export const rrfConfig = {
  userProfile: 'users',
  useFirestoreForProfile: true,
};

const composeEnhancers = import.meta.env.DEV
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  : compose;

const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(thunk.withExtraArgument({ getFirebase, getFirestore })),
  ),
);

export default store;
